import { render, staticRenderFns } from "./presAddHome.vue?vue&type=template&id=6650a22a&scoped=true&"
import script from "./presAddHome.vue?vue&type=script&lang=ts&"
export * from "./presAddHome.vue?vue&type=script&lang=ts&"
import style0 from "./presAddHome.vue?vue&type=style&index=0&id=6650a22a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6650a22a",
  null
  
)

export default component.exports